export const GET_PRICES = "GET_PRICES";
export const GET_PRICE = "GET_PRICE";
export const ADD_PRICE = "ADD_PRICE";
export const DELETE_PRICE = "DELETE_PRICE";
export const UPDATE_PRICE = "UPDATE_PRICE";
